import {Badge, Breadcrumb, Button, Col, Container, Form, Row, Tab, Tabs} from "react-bootstrap";
import styles from "./usermanagement.module.css";
import {useLoaderData, useNavigate, useRouteLoaderData} from "react-router";
import {EditForm} from "./forms/EditForm";
import {useTranslation} from "react-i18next";

export const Edit = ({userId}) => {

    const {currentUser} = useRouteLoaderData("root");
    const user = useLoaderData();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleHome = () => {
        navigate("/")
    }

    return (
        <Container fluid={true}>
            <Row className={"justify-content-end"}>
                <Col className={"d-flex justify-content-start"}>
                    <Breadcrumb className={"mt-3"}>
                        <Breadcrumb.Item onClick={handleHome}>{t('breadcrumbs.home')}</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {t('breadcrumbs.edit')}: {user.firstName} {user.lastName} ({user.login})
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col className={"d-flex justify-content-end"}>
                    <div className={styles.credits}>
                        <h2 className={"text-uppercase"}>
                            {t('credits.header')} <Badge bg="secondary">{currentUser.generalInfo.credits}</Badge>
                        </h2>
                    </div>
                </Col>
            </Row>
            <EditForm user={user}/>
        </Container>
    );

}